import { useEffect, useState } from 'react';

const MOBILE_MAX_WIDTH = 700;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    function checkSize() {
      if (window.innerWidth < MOBILE_MAX_WIDTH) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    }

    window.addEventListener('resize', checkSize);
    checkSize();

    return () => window.removeEventListener('resize', checkSize);
  }, []);

  return isMobile;
}
